"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Vector_1 = __importDefault(require("ol/source/Vector"));
const Vector_2 = __importDefault(require("ol/layer/Vector"));
const Stroke_1 = __importDefault(require("ol/style/Stroke"));
const Fill_1 = __importDefault(require("ol/style/Fill"));
const Utils_1 = require("../Utils");
const CenterUtility_1 = require("../models/CenterUtility");
const style_1 = require("ol/style");
const format_1 = require("ol/format");
const ol_1 = require("ol");
class ZoneBuilder {
    constructor(map = new ol_1.Map()) {
        this.map = map;
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    async centerZone(extent, padding) {
        await (0, CenterUtility_1.center)(this.map, extent, padding);
    }
    createNewLayer() {
        const source = new Vector_1.default();
        const zoneLayer = new Vector_2.default({ source: source });
        (0, Utils_1.addLayerToMap)(zoneLayer, 'zone-layer', 10, this.map);
    }
    async drawZone(mapZoneOptions, centerTime = 600, padding) {
        if (!(0, Utils_1.checkExistLayerById)('zone-layer', this.map)) {
            this.createNewLayer();
        }
        const source = (0, Utils_1.findLayerById)('zone-layer', this.map).getSource();
        // Verificar si ya existe una zona con el mismo nombre
        const existingFeature = source.getFeatures().find(feature => feature.get('name') === mapZoneOptions.zoneName);
        if (existingFeature) {
            return; // Evitar duplicados
        }
        // Crear nueva zona
        const feature = new format_1.WKT().readFeature(mapZoneOptions.geoData, this.projections);
        const fill = new Fill_1.default({ color: mapZoneOptions.fillColor });
        const stroke = new Stroke_1.default({ color: mapZoneOptions.strokeColor, width: mapZoneOptions.strokeWidth });
        const style = new style_1.Style({ fill: fill, stroke: stroke });
        feature.setProperties({
            layerId: 'zone-layer',
            style: style,
            geodata: mapZoneOptions.geoData,
            name: mapZoneOptions.zoneName,
            hover: mapZoneOptions.enableHoverInteraction,
            selectInteraction: mapZoneOptions.enableSelectInteraction,
            avg: mapZoneOptions.avg,
            markers: mapZoneOptions.markers,
            preciseResult: mapZoneOptions.preciseResult,
            modifyInteraction: mapZoneOptions.modifyInteraction || false,
            crop: mapZoneOptions.crop || ''
        });
        source.addFeature(feature);
        feature.setStyle(style);
        const geometry = feature.getGeometry();
        if (mapZoneOptions.centerZone && geometry) {
            await this.centerZone(geometry.getExtent(), padding);
        }
    }
}
exports.default = ZoneBuilder;
